export function makeUser(user) {
  // TODO: ???? todo
  const {
    id,
    session_id,
    balance,
    max_payout,
    wager_balance,
    phone,
    phone_code,
    name,
    email,
    sex,
    has_app_login_last_3_months,
    is_test,
    is_email_verified,
    is_email_verification_sent,
    is_inn_verified,
    is_phone_verified,
    is_phone_verification_sent,
    phone_verification_sent_code,
    phone_verification_sent_phone,
    birthday,
    bonus_balance,
    locked_balance,
    is_payin_allowed,
    is_payout_allowed,
    is_passport_verified,
    is_selfie_verified,
    firstname,
    lastname,
    city,
    created_date,
    is_accepted,
    payin_count,
    is_chance_message_sent,
    has_bonus_mob_login,
    delta_dep_bet,
    next_chance_message_available_in,
    intercom_id,
  } = user

  return {
    id,
    session_id,
    balance: balance > 0
      ? parseFloat(balance / 100)
        .toFixed(2)
      : 0,
    max_payout: max_payout
      ? parseFloat(Math.min(max_payout, balance) / 100)
        .toFixed(2)
      : 0, // why min
    wager_balance: wager_balance > 0
      ? parseFloat(wager_balance / 100)
        .toFixed(2)
      : 0,
    phone,
    phone_code,
    name,
    email,
    sex,
    is_test,
    is_email_verified,
    is_email_verification_sent,
    is_inn_verified,
    is_phone_verified,
    is_phone_verification_sent,
    phone_verification_sent_code,
    phone_verification_sent_phone,
    has_app_login_last_3_months,
    birthday,
    bonuses: parseFloat((balance - Math.min(max_payout, balance)) / 100)
      .toFixed(2), // seems unused
    bonus_balance: bonus_balance > 0
      ? parseFloat(bonus_balance / 100)
        .toFixed(2)
      : 0,
    locked_balance: locked_balance > 0
      ? parseFloat(locked_balance / 100)
        .toFixed(2)
      : 0,
    is_payin_allowed,
    is_payout_allowed,
    is_passport_verified,
    is_selfie_verified,
    firstname,
    lastname,
    city,
    created_date,
    is_accepted,
    payin_count,
    is_chance_message_sent,
    has_bonus_mob_login,
    delta_dep_bet: delta_dep_bet > 0
      ? parseFloat(delta_dep_bet / 100)
      : 0,
    next_chance_message_available_in,
    intercom_id,
  }
}
